import createQueryPath from '@common/path/createQueryPath';
import { ApiResponse } from '@type/web/api';
import {
  EventListQueries,
  EventDetailQueries,
  EventListDataType,
  EventDetailType,
  DEFAULT_SEARCH_QUANTITY,
  EventJoinType,
} from '@type/web/event';

import { AxiosDomain, axiosRequest } from '@api/config';

// 이벤트 참여 API
export const postEventJoin = (
  eventSeq: number,
): Promise<ApiResponse<EventJoinType | null>> => {
  const path = `/mypage/event/${eventSeq}/join`;
  return axiosRequest(AxiosDomain.mainBase, 'post', path, '', '', '', [400]);
};

export const getEventList = (
  eventListQueries: EventListQueries,
): Promise<ApiResponse<EventListDataType[]>> => {
  const queryPath = createQueryPath({
    ...eventListQueries,
    searchQuantity: DEFAULT_SEARCH_QUANTITY,
  });
  const path = `/mypage/event/v3${queryPath}`;

  return axiosRequest(AxiosDomain.mainBase, 'get', path);
};

export const getEventDetail = (
  eventDetailQueries: EventDetailQueries,
): Promise<ApiResponse<EventDetailType>> => {
  const { eventSeq, osType } = eventDetailQueries;
  const queryPath = createQueryPath(eventDetailQueries);
  const path = `/mypage/event/${eventSeq}${queryPath}`;
  const headers = { 'Os-Type': osType };

  return axiosRequest(
    AxiosDomain.mainBase,
    'get',
    path,
    true,
    osType && headers,
  );
};
